<template>
  <VCard class="box-shadow-elevation-1">
    <VCardActions
      class="body-1"
      @click="$emit('collapseTripDetails')"
    >
      {{ $t('checkout.tripDetails') }}
      <VSpacer />
      <VBtn
        icon
      >
        <VIcon>{{ isTripDetailsOpen ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</VIcon>
      </VBtn>
    </VCardActions>
    <VExpandTransition>
      <div v-if="isTripDetailsOpen">
        <SBookingSummary :selectedRides="selectedRides" />
      </div>
    </VExpandTransition>
  </VCard>
</template>
<script lang="ts">
export default {
  name: 'SMobileBookingSummary',
};
</script>

<script setup lang="ts">
import SBookingSummary from '@slg/web-customer-shared/src/components/common/bookingSummary/SBookingSummary';

defineProps({
  isTripDetailsOpen: {
    type: Boolean,
    default: false,
  },
  selectedRides: {
    type: Array,
    default: () => [],
  },
});
</script>
